<template>
  <div class="Message xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="15"></hd-img>
        </div>
        <div class="personal-right">
          <div class="content">
            <div class="flex-space-between">
              <div class="flex-start">
                <div class="line-title"></div>
                <div class="pageTitle">收益详情</div>
              </div>
              <div class="flex-end">
                <el-button type="primary" size="mini" @click="$router.push('/personal/Friend')">返回</el-button>
              </div>
            </div>

            <!--    内容    -->
            <div style="margin-top: 10px">
              <el-table :data="tableData" :header-cell-style="{ background: '#F5F5F5' }" v-if="tableData.length > 0">
                <el-table-column label="编号" type="index" width="60px"></el-table-column>
                <el-table-column prop="name" label="好友">
                  <template slot-scope="scope">
                    <div class="flex-start">
                      <img style="width: 40px; height: 40px; margin-right: 5px" src="../../assets/img/userInfo/heard.png" />
                      <div>
                        <p style="font-size: 12px; margin-right: 5px">{{ scope.row.distributorUser.userName }}</p>
                        <p>{{ scope.row.distributorUser.phone }}</p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="purpose" label="操作" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.purpose == 'recharge'">充值</p>
                    <p v-if="scope.row.purpose == 'withdrawal'">提现</p>
                    <p v-if="scope.row.purpose == 'entryGoods'">商品入账</p>
                    <p v-if="scope.row.purpose == 'refund'">退款</p>
                    <p v-if="scope.row.purpose == 'payVideo'">购买视频</p>
                    <p v-if="scope.row.purpose == 'distribution'">分销获利</p>
                    <p v-if="scope.row.purpose == 'purchaseGoods'">购买商品</p>
                    <p v-if="scope.row.purpose == 'buyMember'">购买会员</p>
                    <p v-if="scope.row.purpose == 'upgradeMember'">升级会员</p>
                    <p v-if="scope.row.purpose == 'renewalUpgrade'">续费升级订单</p>
                    <p v-if="scope.row.purpose == 'renewalMember'">续费会员</p>
                    <p v-if="scope.row.purpose == 'shareMoney'">分享获利</p>
                    <p v-if="scope.row.purpose == 'publicShare'">统一分红</p>
                    <p v-if="scope.row.purpose == 'refundPublicShare'">统一分红退款</p>
                    <p v-if="scope.row.purpose == 'teamShare'">团队分红</p>
                    <p v-if="scope.row.purpose == 'refundTeamShare'">团队分红退款</p>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="贡献收益（元）" align="center">
                  <template slot-scope="scope">
                    <p style="color: #e8200f">{{ scope.row.amount }}</p>
                  </template>
                </el-table-column>
              </el-table>
              <el-empty :image-size="115" v-else></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { converName } from "../../utils/extend";
import { UserInfo } from "../../components/User/UserInfo";
import { clickName } from "../../utils/relation";
export default {
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var userInfo = new UserInfo(this.TokenClient, this.Services.Authorization);
    return {
      tableData: [],
      false: false,
      UserInfoDomain: userInfo,
      userId: this.$route.query.userId,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var _this = this;
      _this.tableData = [];
      _this.UserInfoDomain.ChildrenDistributorsById(
        _this.userId,
        function (data) {
          _this.tableData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}

.personal-box {
  width: 1200px;
  margin: 0 auto;
}

.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  min-height: 740px;
  background: #ffffff;
  box-sizing: border-box;
}
.center-content {
  padding: 0 20px;
}
</style>
<style lang="scss" scoped>
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.item {
  width: 23%;
  position: relative;
  margin-right: 2%;
  margin-bottom: 10px;
  .imgCove {
    width: 100%;
    height: 120px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
    border-radius: 6px;
  }
  .time {
    font-size: 12px;
    color: #999999;
  }
  .isCharge {
    position: absolute;
    top: 0;
    right: 10px;
    background: #ff7f44;
    border-radius: 0px 0px 4px 4px;
    z-index: 1;
    font-size: 12px;
    color: #fff;
    padding: 0 5px;
  }
  .isNoCharge {
    background: #16b2ac;
  }
  .desc {
    width: 90%;
    position: absolute;
    top: 95px;
    right: 5%;
    z-index: 1;
    color: #fff;
  }
}
.item:nth-child(4) {
  margin-right: 0;
}
.list {
  background: #f2f2f2;
  border-radius: 6px;
  padding: 5px 10px;
  margin-bottom: 10px;
}
</style>
<style>
.center-content .el-table .cell {
  cursor: pointer !important;
}

.el-table::before {
  height: 0;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px dashed #ebeef5;
}
</style>
